/*
	ACTIONS

	TODO:
		* extra: window will open center if it's outerbounds
		* extra: dblclick taskbar will center outerbounds windows
		* extra: last window selected will influence the next one opening
		* can icons launching allow duplicable windows?

		4. windows can have splash screens
		5. windows can have opening times (300ms)
		6. windows can have closing times
		7. windows can have related panels = close parent, others close (eg ICU). Only main obj can be opened via terminal tho
		8. extra: windows that open from icons transition out from those icons

		9. PATHS
		* 'path' points to the physical location of the file.
		* It must physically exist in the user's fileSystem ($store) to open.
		* Using just the path ensures the same function can be used from the Command Line
		* EG. open ~/Desktop/filename.mp4
		* EG. open .   (will open the current folder etc - do later)

		* importing the file by path getter from fileSystem
		* const fileInFileSystem = getFileByPath(path); // eg. '/desktop/messenger.exe';
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import Faker from 'faker';

//------------------------------------------------------------
// OPEN FILE (eventually becomes openWindow)
//------------------------------------------------------------

const openFile = ({dispatch, state, commit, getters}, path) => {

	// return the breadcrumbs array, grab the last one (current)
	const gameObject = getters.getDirectoriesFromPath(path).slice(-1)[0].node;

	//===========================================
	// this MUST EXIST in the FileSystem, otherwise throw error
	//===========================================

	if (gameObject) {

		//===========================================
		// SHOULD THE WINDOW OPEN?
		//
		// 1. Does it already exist in state.openWindows?
		// 2. Is it duplicable?
		// *  NOTE: we go by path, not object; since it's potentially duplicable.
		//          No two paths can exist in the file system. Just like a normal OS.
		//===========================================

		const existingWindowDuplicable = state.openWindows.find(item => item.path == gameObject.path && item.windowData.duplicable);
		const existingWindowNonDuplicable = state.openWindows.find(item => item.path == gameObject.path && !item.windowData.duplicable);

		// tag new window with UUID for loop key
		const clonedGameObject = JSON.parse(JSON.stringify(gameObject)); // we don't want ALL the recent's settings -- or do we? *
			  clonedGameObject.uuid = Faker.random.uuid();

		//===========================================
		// WINDOW ALREADY EXISTS; NON-DUPLICABLE -> EXIT
		//===========================================

		if (existingWindowNonDuplicable) {
			dispatch('minimizeWindow', { target: existingWindowNonDuplicable, bool: false });
			return false;
		}

		//===========================================
		// WINDOW ALREADY EXISTS; DUPLICABLE -> OFFSET X,Y + TRANSFER DIMENSIONS OVER
		//===========================================

		if (existingWindowDuplicable) {
			const mostRecentOpenWindow = state.openWindows.slice().reverse().find(item => item.path == gameObject.path);

			// position new window based on old x,y and dimensions
			positionWindow(clonedGameObject, mostRecentOpenWindow);
		}

		//===========================================
		// NO WINDOWS EXIST; ADD NEW
		// https://trello.com/c/3vw2sxvq/54-object-assign-vs-json-clone
		//===========================================

		if (!existingWindowDuplicable && !existingWindowNonDuplicable) {
			const mostRecentClosedWindow = state.closedWindows.slice().reverse().find(item => item.path == gameObject.path);

			// check closed windows first, can read windowData
			if (mostRecentClosedWindow) {
				positionWindow(clonedGameObject, mostRecentClosedWindow);
				// can also remove it from closedWindows here
			}
		}

		//===========================================
		// >>> ADD WINDOW AND OPEN
		//===========================================

		commit('ADD_WINDOW', clonedGameObject);
		dispatch('selectWindow', clonedGameObject);
	}

	//===========================================
	// ERRORS
	//===========================================

	else {
		console.warn('Oops! No file exists for that path.')
	}
}

//------------------------------------------------------------
// POSITION WINDOW
//------------------------------------------------------------

const positionWindow = (newTarget, oldTarget) => {
	// * we don't want maximise to carry over, or minimize etc
	newTarget.windowData.x = oldTarget.windowData.x + 30;
	newTarget.windowData.y = oldTarget.windowData.y + 30;
	newTarget.windowData.width = oldTarget.windowData.width;
	newTarget.windowData.height = oldTarget.windowData.height;
}

//------------------------------------------------------------
// SELECT WINDOW
//------------------------------------------------------------

const selectWindow = ({state, commit}, target) => { // can pass it object or UID

	// create temp array of window Z props for evaluation
	const zArray = state.openWindows.map(item => item.windowData.z);

	// determine heighest z available
	const highestZ = zArray.length ? Math.max(...zArray) : 0;

	// deselect all
	commit('DESELECT_WINDOWS');

	// select window and assign the highest possible z
	commit('SELECT_WINDOW', {
		target: target,
		newZ: highestZ + 1
	});
}

//------------------------------------------------------------
// CLOSE WINDOW
//------------------------------------------------------------

const closeWindow = ({commit}, target) => {
	commit('REMOVE_WINDOW', target);
}

//------------------------------------------------------------
// MINIMIZE WINDOW
//------------------------------------------------------------

const minimizeWindow = ({dispatch, commit}, payload) => {

	// only select window (change z) when UN-minimizing. Bring back to focus.
	if (payload.target.windowData.minimized || payload.bool === false) {
		dispatch('selectWindow', payload.target);
	}

	commit('MINIMIZE_WINDOW', {
		target: payload.target,
		bool: payload.bool
	});
}

//------------------------------------------------------------
// MAXIMIZE WINDOW
// see onActivated in WindowManagerDragger)
//------------------------------------------------------------

const maximizeWindow = ({dispatch, commit}, target) => {
	dispatch('selectWindow', target)
		.then(() => {
			commit('MAXIMIZE_WINDOW', target);
	});
}

//------------------------------------------------------------
// UPDATE WINDOW
//------------------------------------------------------------

const updateWindow = ({commit}, payload) => {
	commit('UPDATE_WINDOW', {
		target: payload.target,
		x: payload.x,
		y: payload.y,
		width: payload.width || null, // dragstop won't pass a width
		height: payload.height || null
	});
}

//------------------------------------------------------------
// SIMPLE
//------------------------------------------------------------

const clearWindows = ({commit}) => {
	commit('CLEAR_WINDOWS');
}

const deselectWindows = ({commit}) => {
	commit('DESELECT_WINDOWS');
}

const minimizeWindows = ({commit}) => {
	commit('MINIMIZE_WINDOWS');
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	clearWindows,
	closeWindow,
	deselectWindows,
	maximizeWindow,
	minimizeWindow,
	minimizeWindows,
	openFile,
	selectWindow,
	updateWindow
}
//===========================================
//
//===========================================